/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-hot-goods.vue?vue&type=template&id=2df5152a&scoped=true"
import script from "./pc-hot-goods.vue?vue&type=script&lang=js"
export * from "./pc-hot-goods.vue?vue&type=script&lang=js"
import style0 from "./pc-hot-goods.vue?vue&type=style&index=0&id=2df5152a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5152a",
  null
  
)

export default component.exports